import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import type { Core as CoreTrackingTypes } from "@website/tracking/types/core";
import { addEventToTracking } from "@website/tracking/user";
import { Metric } from "@website/widget/scripts/web-vitals/types";
import type { WebVitalDiagnosticsPayload } from "@website/widget/scripts/web-vitals/utils";
import { getDetailedDiagnostics } from "@website/widget/scripts/web-vitals/utils";

type CoreWebVitalMetric = NonNullable<CoreTrackingTypes["core_web_vitals"]>;

export function reportWebVitalMetric(metric: Metric): void {
  if (metric.name === "FID" || metric.rating === "good") return;

  const diagnostics: WebVitalDiagnosticsPayload =
    getDetailedDiagnostics(metric);

  const coreWebVitals: CoreWebVitalMetric = {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
    id: metric.id,
    navigation_type: metric.navigationType,
    label: "",
    attribution: {},
    diagnostics: diagnostics as CoreWebVitalMetric["diagnostics"]
  };

  addEventToTracking(USER_TRACKING_EVENTS.WEB_VITAL_MEASURED, {
    product: "core",
    core_web_vitals: coreWebVitals
  });
}
